<div>
  <yc-i18n *ngIf="scheduledDate"
    [key]="fundingSourceType === FundingSourceType.DOLLARS && !isForApplicantPortal ?
      'GLOBAL:textAvailableToProcessDynamic' :
      'GLOBAL:textPaymentDate'"
    [context]="{
      date: scheduledDate | ycStartOfDayDateFormatter
    }"
    [defaultValue]="fundingSourceType === FundingSourceType.DOLLARS ?
      'Available to process __date__' :
      'Payment date __date__'">
  </yc-i18n>
</div>
<small class="d-block">
  <div *ngIf="issuedDate">
    <yc-i18n
      key="GLOBAL:textIssuedDynamic"
      [context]="{
        date: issuedDate | ycStartOfDayDateFormatter
      }"
      defaultValue="Issued __date__">
    </yc-i18n>
  </div>
  <div *ngIf="clearedDate"
    class="d-block">
    <yc-i18n
      key="GLOBAL:textClearedDynamic"
      [context]="{
        date: clearedDate | ycStartOfDayDateFormatter
      }"
      defaultValue="Cleared __date__">
    </yc-i18n>
  </div>
</small>